import { ProjectCode } from '@constants'
import { type CosignContextProps } from '../components/useContextCosign'
import { getWpUserRegion } from '../utils/getWpUserRegion'

// TODO: 未來要做跨品牌 + 多國
export const privacypoliciesLinkMap: Record<string, string> = {
  [ProjectCode.DCS]: 'https://www.dogcatstar.com/terms',
  [ProjectCode.HM]: 'https://heromamapet.com/privacypolicies',
  [ProjectCode.LM]: 'https://litomon.com/隱私權政策',
  [ProjectCode.MNP]: 'https://ladynpet.com/privacy-policy',
  [ProjectCode.AQUA]: 'https://aquacorners.com/privacy-policy',
  [ProjectCode.PP]: 'https://purialpet.com/privacy-policy',
  [ProjectCode.PM]: 'https://pawswellpet.com/privacy-policy',
  [ProjectCode.YT]: 'https://yummytiger.com/privacy-policy',
  [ProjectCode.RS]: 'https://rihshin.com/privacy-policy',
}
// TODO: 未來要做跨品牌 + 多國
export const intellectualLinkMap: Record<string, string> = {
  [ProjectCode.DCS]: 'https://www.dogcatstar.com/claim',
  [ProjectCode.HM]: 'https://heromamapet.com/intellectual',
  [ProjectCode.LM]: 'https://litomon.com/intellectual_property',
  [ProjectCode.MNP]: 'https://ladynpet.com/intellectualpropertyrights',
  [ProjectCode.AQUA]: 'https://aquacorners.com/intellectualproperty',
  [ProjectCode.PP]: 'https://purialpet.com/privacy-policy',
  [ProjectCode.PM]: 'https://pawswellpet.com/privacy-policy',
  [ProjectCode.YT]: 'https://yummytiger.com/privacy-policy',
  [ProjectCode.RS]: 'https://rihshin.com/privacy-policy',
}

const hmServerLink: Record<string, string> = {
  TW: 'http://line.me/ti/p/@HEROMAMA',
  HK: 'https://wa.me/886938919220/?text=HI',
}
const hmCosignConfig: CosignContextProps = {
  environment: 'wordPress',
  projectCode: ProjectCode.HM,
  lineLogin: true,
  facebookLogin: false,
  googleLogin: false,
  emailLogin: false,
  lineSubscribe: true,
  privacypoliciesLink: privacypoliciesLinkMap[ProjectCode.HM] || '',
  intellectualLink: intellectualLinkMap[ProjectCode.HM] || '',
  serverLink: hmServerLink[getWpUserRegion()] || '',
  title: 'HeroMaMa',
}

const dcsServerLink: Record<string, string> = {
  TW: 'https://line.me/R/ti/p/%40zlo8319e',
  HK: 'https://wa.me/886936280630/?text=HI',
  SG: 'https://line.me/R/ti/p/%40zlo8319e',
  MY: 'https://line.me/R/ti/p/%40zlo8319e',
}
const dcsCosignConfig: CosignContextProps = {
  environment: 'wordPress',
  projectCode: ProjectCode.DCS,
  lineLogin: true,
  facebookLogin: true,
  googleLogin: true,
  emailLogin: true,
  lineSubscribe: true,
  privacypoliciesLink: privacypoliciesLinkMap[ProjectCode.DCS] || '',
  intellectualLink: intellectualLinkMap[ProjectCode.DCS] || '',
  serverLink: dcsServerLink[getWpUserRegion()] || '',
  title: 'DogCatStar',
}

const lmServerLink: Record<string, string> = {
  TW: 'http://line.me/ti/p/@LitoMon',
  HK: 'https://wa.me/886925352300/?text=HI',
}
const lmCosignConfig: CosignContextProps = {
  environment: 'wordPress',
  projectCode: ProjectCode.LM,
  lineLogin: true,
  facebookLogin: true,
  googleLogin: false,
  emailLogin: true,
  lineSubscribe: true,
  privacypoliciesLink: privacypoliciesLinkMap[ProjectCode.LM] || '',
  intellectualLink: intellectualLinkMap[ProjectCode.LM] || '',
  serverLink: lmServerLink[getWpUserRegion()] || '',
  title: '怪獸部落',
}

const pmServerLink: Record<string, string> = {
  TW: 'https://lin.ee/W6ndcwX',
}
const pmCosignConfig: CosignContextProps = {
  environment: 'wordPress',
  projectCode: ProjectCode.PM,
  lineLogin: true,
  facebookLogin: false,
  googleLogin: false,
  emailLogin: true,
  lineSubscribe: true,
  privacypoliciesLink: privacypoliciesLinkMap[ProjectCode.PM] || '',
  intellectualLink: intellectualLinkMap[ProjectCode.PM] || '',
  serverLink: pmServerLink[getWpUserRegion()] || '',
  title: '毛掌醫學',
}

const ppServerLink: Record<string, string> = {
  TW: 'https://line.me/R/ti/p/@516fftuh',
}
const ppCosignConfig: CosignContextProps = {
  environment: 'wordPress',
  projectCode: ProjectCode.PP,
  lineLogin: true,
  facebookLogin: false,
  googleLogin: false,
  emailLogin: true,
  lineSubscribe: true,
  privacypoliciesLink: privacypoliciesLinkMap[ProjectCode.PP] || '',
  intellectualLink: intellectualLinkMap[ProjectCode.PP] || '',
  serverLink: ppServerLink[getWpUserRegion()] || '',
  title: '日日貓砂',
}

const rsServerLink: Record<string, string> = {
  TW: 'https://lin.ee/xnUAQK6D',
}
const rsCosignConfig: CosignContextProps = {
  environment: 'wordPress',
  projectCode: ProjectCode.RS,
  lineLogin: true,
  facebookLogin: true,
  googleLogin: false,
  emailLogin: true,
  lineSubscribe: true,
  privacypoliciesLink: privacypoliciesLinkMap[ProjectCode.RS] || '',
  intellectualLink: intellectualLinkMap[ProjectCode.RS] || '',
  serverLink: rsServerLink[getWpUserRegion()] || '',
  title: '日幸',
}

const ytServerLink: Record<string, string> = {
  TW: 'https://replug.link/d697a070',
}
const ytCosignConfig: CosignContextProps = {
  environment: 'wordPress',
  projectCode: ProjectCode.YT,
  lineLogin: true,
  facebookLogin: false,
  googleLogin: false,
  emailLogin: true,
  lineSubscribe: true,
  privacypoliciesLink: privacypoliciesLinkMap[ProjectCode.YT] || '',
  intellectualLink: intellectualLinkMap[ProjectCode.YT] || '',
  serverLink: ytServerLink[getWpUserRegion()] || '',
  title: '虎留香',
}

const mnpServerLink: Record<string, string> = {
  TW: 'https://lin.ee/wfEHXlI',
  HK: 'https://wa.me/886936536437/?text=HI',
  US: 'mailto:service@ladynpet.com',
}
const mnpEnableEmailLogin: Partial<Record<string, boolean>> = {
  TW: false,
  HK: false,
  US: true,
}
const mnpCosignConfig: CosignContextProps = {
  environment: 'wordPress',
  projectCode: ProjectCode.MNP,
  lineLogin: true,
  facebookLogin: true,
  googleLogin: true,
  emailLogin: mnpEnableEmailLogin[getWpUserRegion()],
  lineSubscribe: true,
  privacypoliciesLink: privacypoliciesLinkMap[ProjectCode.MNP] || '',
  intellectualLink: intellectualLinkMap[ProjectCode.MNP] || '',
  serverLink: mnpServerLink[getWpUserRegion()] || '',
  title: 'Lady N',
}

const aquaServerLink: Record<string, string> = {
  TW: 'https://lin.ee/P9fElAY',
}
const aquaCosignConfig: CosignContextProps = {
  environment: 'wordPress',
  projectCode: ProjectCode.AQUA,
  lineLogin: true,
  facebookLogin: false,
  googleLogin: false,
  emailLogin: false,
  lineSubscribe: true,
  privacypoliciesLink: privacypoliciesLinkMap[ProjectCode.AQUA] || '',
  intellectualLink: intellectualLinkMap[ProjectCode.AQUA] || '',
  serverLink: aquaServerLink[getWpUserRegion()] || '',
  title: '角落水族',
}

export const cosignConfigMap = {
  [ProjectCode.HM]: hmCosignConfig,
  [ProjectCode.DCS]: dcsCosignConfig,
  [ProjectCode.LM]: lmCosignConfig,
  [ProjectCode.PM]: pmCosignConfig,
  [ProjectCode.PP]: ppCosignConfig,
  [ProjectCode.RS]: rsCosignConfig,
  [ProjectCode.YT]: ytCosignConfig,
  [ProjectCode.MNP]: mnpCosignConfig,
  [ProjectCode.AQUA]: aquaCosignConfig,
} satisfies Record<Exclude<ProjectCode, 'FP' | 'HN' | 'ST'>, CosignContextProps>
